var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bordas total-leitos pt-0"},[_c('span',[_vm._v("Total de Leitos: "+_vm._s(_vm.info.length))])])}
var staticRenderFns = []

export { render, staticRenderFns }